account = function (admin, cui_enabled) {
  var cui_enabled = cui_enabled;
	var objHierarchy = hierarchy(cui_enabled);
	var objAccount = list(null, cui_enabled);
	var domObject = dom(cui_enabled);
	var objDialog = dialog();
	var listObject = list(null, cui_enabled);

	if (typeof admin === 'undefined') {
		admin = false;
	}

	/* initialize growls */
	$('#growls').notify();

	/* globals for the removing user wizards */
	var numStepsSelectUser = 0;
	var numStepActionSelectUser = 0;
	var numOriginatorProposals = 0;
	var numRolesWithoutUsers = 0;

	var stepsSelectUser = '';
	var stepActionSelectUser = '';
	var originatorProposals = '';
	var rolesWithoutUsers = '';

	var replaceAPStepsResult = '';
	var replaceStepActionResult = '';
	var replaceOriginatorResult = '';
	var replaceRoleUserResult = '';

	var originatorTask = 'replace';

	var apNames = '';
	var proposalNames = '';

	/* parameters for removing a role */
	var userRole = '';
	var rolesUsers = '';
	var originalUserName = '';

	var replaceUserRoleResults = '';
	var stepsWithRole = '';

	var numStepsWithRole = 0;

	var apEditmodeOriginal = [];
	var apEditmodeEditing = [];



	objAccount.toggleParticipantSummary = function(obj) {
		if($(obj).siblings('.participant-summary-block').is(':visible'))
		{
			$(obj).children('div').removeClass('down');
			$(obj).children('div').addClass('up');
		}
		else
		{
			$('.participant-summary-toggle').children('div').removeClass('down');
			$('.participant-summary-toggle').children('div').addClass('up');
			$(obj).children('div').removeClass('up');
			$(obj).children('div').addClass('down');
		}

		var isToggled = $(obj).parent('div').children('.participant-summary-block').hasClass('open-summary');

		// check to see if its already toggled
		if(isToggled)
		{
			// close summaries
			$('.participant-summary-block').removeClass('open-summary');
		}
		else
		{
			// close all summaries and the open the clicked summary
			$('.participant-summary-block').removeClass('open-summary');

			$(obj).parent('div').children('.participant-summary-block').addClass('open-summary');
		}
	};


	objAccount.removeRoleInUser = function(obj, userId, roleId, replacement, type) {
		$.ajax({
			url: '/admin/account:' + userId + '/removeRoleFromUser.json',
			data: {roleId:roleId, replacement:replacement},
			type: 'DELETE',
			beforeSend: function() {
				objDom.addMask('#entity-roles-choosen');
				objDom.addMask('#roles-choosen-' + userId);
			},
			success: function(){
				objDom.removeMask('#entity-roles-choosen');
				objDom.removeMask('#roles-choosen-' + userId);
				objAccount.showCommittees(userId);
			}
		});

		if ( $(obj).parents('div#add-roles-dialog').size() > 0 ) {

			// add to new one if tpye is replace
			if(type == 'replace')
			{
				newUserId = replacement['userId'];
				$('li#user-' + userId + '-role-saved-' + roleId).clone(true).attr('id', 'user-' + newUserId + '-role-saved-' + roleId).appendTo('#roles-choosen-' + newUserId);

				var name = $('#entity-roles-available option:selected').text();
				var entityName = ($('#entities-available option:selected').text()).match(/^\s*(.*)/)[1];
				roleId = ($('#entity-roles-available').val()).replace('role-available-','');
				objAccount.updateRoleListFromDialog(name, entityName, roleId, userId);
			}

			// if in dialog, then remove from dialog
			$('li#role-choosen-' + roleId).remove();

			// If no roles, display message
			if($('ul#entity-roles-choosen li').size() < 1) {
				$('ul#entity-roles-choosen').append('<li class="no-roles">No roles have been assigned to this user.</li>');
			}

			// Add the role back to the available roles
			$('#entity-roles-available option[value="role-available-' + roleId + '"]').removeAttr('disabled');
			objAccount.cleanupRoleSelect();

		} else {

			// add to new one
			if(type == 'replace')
			{
				newUserId = replacement['userId'];
				$('li#user-' + userId + '-role-saved-' + roleId).clone(true).attr('id', 'user-' + newUserId + '-role-saved-' + roleId).appendTo('#roles-choosen-' + newUserId);
			}
		}

		// summary page
		$('li#user-' + userId + '-role-saved-' + roleId).remove();

		if($('ul#roles-choosen-' + userId + ' li:not(.no-roles)').size() < 1) {
			$('ul#roles-choosen-' + userId + ' li.no-roles').remove();
			$('ul#roles-choosen-' + userId).append('<li class="no-roles">No roles have been assigned to this user.</li>');
		}

		var items = [];
		var roleNames = [];
		var roleAndEntityNames = [];

		// loop and build list
		$('#roles-choosen-' + userId + ' li.role').each(function(){
			items.push(parseInt($(this).find('input[name="id"]').val(), 10));
			roleNames.push($(this).find('input[name="name"]').val());
			roleAndEntityNames.push($(this).find('input[name="name"]').val() + ' - ' + $(this).find('input[name="entity"]').val());
		});

		// Turn role and entity names into a string
		var message = roleAndEntityNames.join(", ");

		// if no roles, display 'No roles have been assigned'
		if ( message.length === 0 ) {
			message = 'No roles have been assigned to this user.';
		} else if (message.length > 72) {
			// if roles string is greater than 72, concat the string
			message = message.substring(0,72) + '&hellip;';
		}

		$('#curriculog-list-column-results-content #detail-'+ userId +' .roles').html(message);

		$('div.qtip-active').remove();
		objAccount.verticalStretchList();
	};


	objAccount.checkMessages = function() {
		if($('#users-to li').length > 0) {
			$('.send-message-tab').closest('ul').show();
		} else {
			$('.send-message-tab').closest('ul').hide();
		}
	};


	objAccount.addRole = function() {

		var userId = $('#account-details-id').val();
		var name = $('#entity-roles-available option:selected').text();
		var entityName = ($('#entities-available option:selected').text()).match(/^\s*(.*)/)[1];
		var roleId = ($('#entity-roles-available').val()).replace('role-available-','');

		if(roleId !== '') {
			$.ajax({
				url: '/account:' + userId + '/addRole.json',
				type: 'post',
				data: {roleId:roleId},
				beforeSend: function() {
					objDom.addMask('#entity-roles-choosen');
				},
				success: function(result){

					objDom.removeMask('#entity-roles-choosen');

					if (parseInt(result.success, 10) == 1) {
						objAccount.updateRoleListFromDialog(name, entityName, roleId, userId);

					} else {
						$('#curriculog-list-column-results-content #detail-'+ userId +' .roles').text('An Error has Occurred.');
					}
				}
			});
		}
	};

	objAccount.updateRoleListFromDialog = function(name, entityName, roleId, userId) {

		var roleAndEntityNames = [];
		$('#entity-roles-choosen li:not(.no-roles)').each(function(index, item) {
			var name = $(item).find('input[name="name"]').val();
			var entity = $(item).find('input[name="entity"]').val();
			roleAndEntityNames.push(name + ' - ' + entity);
		});

		$('#role-choosen-clone').clone(true)
			.append(name + ' - ' + entityName)
			.attr('id', 'role-choosen-' + roleId)
			.appendTo('#entity-roles-choosen');
		roleAndEntityNames.push(name + ' - ' + entityName);
		$('#role-choosen-' + roleId).find('input[name="id"]').val(roleId)
			.siblings('input[name="name"]').val(name)
			.siblings('input[name="entity"]').val(entityName);
		$('#entity-roles-available option[value="role-available-' + roleId + '"]').removeAttr('selected').attr('disabled',true);
		objAccount.cleanupRoleSelect();

		if ( $('#entity-roles-choosen li').size() > 1 ) {
			$('#entity-roles-choosen li.no-roles').remove();
			$('#roles-choosen-' + userId + ' li.no-roles').remove();
		}

		// save to user role List
		$('#role-saved-clone').clone(true)
			.append(name + ' - ' + entityName)
			.attr('id', 'user-' + userId + '-role-saved-' + roleId)
			.appendTo('#roles-choosen-' + userId);
		$('#user-' + userId + '-role-saved-' + roleId).find('input[name="id"]').val(roleId)
			.siblings('input[name="name"]').val(name)
			.siblings('input[name="entity"]').val(entityName);
		$('#user-' + userId + '-role-saved-' + roleId).find('a.curriculog-widget').attr('title', '').qtip({content: {text: 'Remove Role'}, style: {tip: true}});

		// Turn role and entity names into a string
		var message = roleAndEntityNames.join(", ");

		// if no roles, display 'No roles have been assigned'
		if ( message.length === 0 ) {
			message = 'No roles have been assigned to this user.';
		} else if (message.length > 72) {
			// if roles string is greater than 72, concat the string
			message = message.substring(0,72) + '&hellip;';
		}

		$('#curriculog-list-column-results-content #detail-'+ userId +' .roles').html(message);

		// find committees associated with this role
		objAccount.showCommittees(userId);

		objAccount.verticalStretchList();
	};


	objAccount.addRoles = function(accountId) {
		// Display list of entities then choose roles by entity
		$('#account-details-id').val(accountId);

		//$('#entity-roles-available, #entity-roles-choosen').empty();
		$('#entity-roles-choosen').empty();

		// Add the roles that exist on the page
		var items = [];
		$('#roles-choosen-' + accountId + ' li:not(.no-roles)').each(function(){
			var roleId = $(this).find('input[name="id"]').val();
			var name = $(this).find('input[name="name"]').val();
			var entityName = $(this).find('input[name="entity"]').val();
			var roleTypeID = $(this).find('input[name="roleTypeID"]').val();

			items.push(parseInt(roleId, 10));

			var displayName = '<div class="ellipsis">' + name + ' - ' + entityName + '</div>';

			$('#role-choosen-clone').clone(true).append(displayName).attr('id', 'role-choosen-' + roleId).appendTo('#entity-roles-choosen');
			$('#role-choosen-' + roleId).find('input[name="id"]').val(roleId)
										.siblings('input[name="name"]').val(name)
										.siblings('input[name="entity"]').val(entityName)
										.siblings('input[name="roleTypeID"]').val(roleTypeID);
			// Add tooltip
			$('#role-choosen-' + roleId).find('a.curriculog-widget').attr('title', '').qtip({content: {text: 'Remove Role'}, style: {tip: true}});

			// Add committee icon
			objAccount.showCommittees(accountId);
		});

		var choosenRoles = $('#entity-roles-choosen li').size();
		if ( choosenRoles > 1 ) {
			$('#entity-roles-choosen li.no-roles').remove();
		} else if (choosenRoles < 1) {
			$('#entity-roles-choosen').append('<li class="no-roles">No roles have been assigned to this user.</li>');
		}

		objAccount.showRoles($('#entities-available').val());

		var dialog = objDialog.createDOMDialog('add-roles-dialog', function(dialog, defaults) {

			// Actions
			defaults.buttons = {
				'Done Adding Roles': function() {
					$(this).dialog('close');
					$('#entity-roles-available, #entity-roles-choosen').empty();
				}
				//},
				// removed this because it does the same thing as above
				//Cancel: function() {
					//$(this).dialog('close');
					//$('#entity-roles-available, #entity-roles-choosen').empty();
				//}
			};

			// this is needed for firefox. Without it you cannot open the seletbox until you blur off it
			// and then it will open. This blurs off it to begin with so that it is openable.
			defaults.open = function() {
				$('#entities-available').blur();
			};

			defaults.close = function() {
				$('div.qtip-active').remove();
			};

			$(dialog).dialog(defaults);
		});
	};


	objAccount.showRoles = function(entityId) {
		$('#entity-roles-available').empty();
		$('#entity-roles-available').attr('disabled',false);
		$('#add-role').attr('disabled', false);

		if (entityId === undefined) {
			return false;
		}

		var url = '/';
		if (admin != 'false') {
			url = '/admin/';
		}

		$.get(url + 'entity:' + entityId + '.json', {}, function(data) {
			if(data.entity.roles.length > 0) {
				var items = [];

				var id = $('.summary').attr('id').match(/summary-\w*-(\d*)/)[1];
				$('#roles-choosen-' + id + ' li input[name="id"]').each(function(){
					items.push(parseInt($(this).val(), 10));
				});

				$.each(data.entity.roles, function(index2, role) {
					// If role has not been choosen display it

					$('<option></option>').text(role.name)
						.attr('value', 'role-available-' + role.id)
						.appendTo('#entity-roles-available');
					if ($.inArray(role.id, items) >= 0) {
						$('#entity-roles-available option[value="role-available-' + role.id+ '"]').attr('disabled',true);
					}
				});

				if ($('#entity-roles-available').find('option:enabled').length === 0 || $('#summary-user-0').length === 1){
					$('#add-role').attr('disabled', 'disabled');
				}

				// Run dropdown cleanup
				objAccount.cleanupRoleSelect();

			} else {
				$('#add-role').attr('disabled', 'disabled');
				$('#entity-roles-available').attr('disabled', 'disabled');
				$('#entity-roles-available').append('<option class="no-roles" value="" selected disabled="disabled">No Roles Available</li>');
			}

			Curriculog.Actions.log('entity-roles-loaded');
		});
	};

	objAccount.cleanupRoleSelect = function() {
		// Assume the list is fully functioning
		$('#entity-roles-available').removeAttr('disabled');
		$('#entity-roles-available option[value=""]').remove();

		// Disable all items in the list from the select
		if  ( ($('#entity-roles-available option').length  == $('#entity-roles-available option:disabled').length)  || ( $('#entity-roles-available option').length < 1 ) ) {
			$('<option value="" disabled="disabled" selected>No Roles Available</option>').insertBefore('#entity-roles-available option:first');
			$('#entity-roles-available').attr('disabled',true);
		} else {
			// Select the proper role
			$('#entity-roles-available').val($("#entity-roles-available option:not(:disabled):first").val());
		}
	};

	objAccount.updateAgendaAdmin = function(obj) {
		var buttonName = $(obj).attr('id').match(/user-(\d*)-committee-(\d*)-admin/);
		var userId = buttonName[1];
		var committeeId = buttonName[2];
		var agendaAdmin = ($(obj).is(':checked')) ? 1 : 0;

		if(committeeId !== '') {
			$.ajax({
				url: '/account:' + userId + '/updateAgendaAdmin.json',
				type: 'post',
				data: {
					committee: committeeId,
					agendaAdmin: agendaAdmin
				},
				success: function(result){

					//objDom.removeMask('#committees-chosen');

					if (parseInt(result.success, 10) === 0) {
						objAccount.noMoreAgendaAdmins();
						$('#user-' + userId + '-committee-' + committeeId + '-admin').attr("checked","checked");
						// $('#curriculog-list-column-results-content #detail-'+ userId +' .account-committees').text('An Error has Occurred.');
					}
				}
			});
		}
	};

	objAccount.noMoreAgendaAdmins = function() {

		var dialog = objDialog.createBasicWarningDialog('cannot-remove', function(dialog, defaults) {

			// Message
			$(dialog).append(
				'This user is the only agenda administrator for this ' +
				'committee. You need to add a new agenda administrator before' +
				'you can remove this user as Agenda Administrator.'
			);
			// Actions
			defaults.buttons = {
				'OK': function() {
					$(this).dialog('close');
					$(this).remove();
				}
			};
			$(dialog).dialog(defaults);
		});
	};

	objAccount.showCommittees = function(user) {
		$.ajax({
			url: '/account:' + user + '/getRoles.json',
			type: 'get',
			beforeSend: function() {
				objDom.addMask('.account-committees');
				$('div.qtip-active').remove();
			},
			success: function(result){
				$('#committees-chosen-' + user).empty();
				if (result.user.roles !== '') {
					var roles = result.user.roles;

					$(roles).each(function(index, role) {
						if (role.committee === undefined || role.committee.length === 0) {
							return;
						}

						var committeeItem = $('#committee-chosen-clone').clone().removeAttr('id');
						var input = $(committeeItem).find('input');
						var label = $(committeeItem).find('label');

						$(input).attr('name','user-'+ user +'-committee-'+ role.committee.id +'-admin');
						$(input).attr('id','user-'+ user +'-committee-'+ role.committee.id +'-admin');
						if ($.inArray(parseInt(user, 10), role.committee.agendaAdmin) > -1) {
							$(input).attr('checked', true);
						}
						$(label).attr('for','user-'+ user +'-committee-'+ role.committee.id +'-admin');
						$(committeeItem).append(role.committee.name);
						$('#committees-chosen-' + user).append(committeeItem);

						// For roles list and entity dialog, determine if item has committee and create icon
						if ($('#role-choosen-' + role.id + ' .entity-role-committee').length === 0) {
							$('#role-choosen-' + role.id).append('<img class="entity-role-committee tip" src="/images/icons/flat/committees.png" title="' + role.committee.name + '">');
						}
						if ($('#user-' + user + '-role-saved-' + role.id + ' .entity-role-committee').length === 0) {
							$('#user-' + user + '-role-saved-' + role.id).append('<img class="entity-role-committee tip" src="/images/icons/flat/committees.png" title="' + role.committee.name + '">');
						}
					});

				} else {
					$('#committees-chosen-' + user).append('<li class="no-committees">None of the roles assigned to this user are associated with committees</li>');
				}
				objDom.removeMask('.account-committees');
			}
		});
	};

	objAccount.updateCollaborator = function(clicked) {
		var listItem = $(clicked).parents('li.open-summary');
		// get id
		var accountId = $(listItem).attr('id').substring(7);
		// get name
		var name = $(listItem).find('input[name="name"]').val();
		var firstName = $(listItem).find('input[name="firstName"]').val();
		var lastName = $(listItem).find('input[name="lastName"]').val();

		if ( $('#collaborator-' + accountId).length === 0 ) {
			$('.collaborators .note').text('').removeAttr('tabindex');
			// Add collaborator
			$('#collaborator-clone').clone(true).prepend(lastName + ', ' + firstName).attr('id', 'collaborator-' + accountId).attr('tabindex', 0).appendTo('#users-to');
			$('#collaborator-' + accountId).find('input[name="id"]').val(accountId);
			$(listItem).addClass('collab').find('button.action-remove-collaborator').addClass('active').siblings().removeClass('active');
			objAccount.resetMessageButtons();

			// Add tooltip
			$('#collaborator-' + accountId).find('a.curriculog-widget').attr('title', '').qtip({content: {text: 'Remove Collaborator'}, style: {tip: true}});
		} else {
			// remove collaborator
			objAccount.removeCollaborator(accountId);
		}
		objAccount.checkMessages();
	};

	objAccount.removeCollaborator = function(collaboratorId) {
		// remove collaborator
		$('div.qtip-active').remove();
		$('#collaborator-' + collaboratorId).remove();

		$("#detail-" + collaboratorId).removeClass('collab').find('button.action-remove-collaborator').removeClass('active');
		if ($('#users-to li').length === 0) {
			$('.collaborators .note').text('Click the email icon next to the user you want to add to this message.').attr('tabindex', 0);
		}
		objAccount.resetMessageButtons();
		objAccount.checkMessages();
		objDom.verticalStretchList();

	};

	objAccount.hideAccountFlyout = function(){
		$('.open-summary').removeClass('active');
		var listWidth = $('#curriculog-list-column').outerWidth();

		if ($('#curriculog-hierarchy-column').length) {
			listWidth = $('#curriculog-hierarchy-column').outerWidth();
		}

		var detailClosed = listWidth - $('#curriculog-summary-column').outerWidth() - 1;

		if ( $('#curriculog-dashboard-column').hasClass('active') === false && $('#curriculog-send-message-column').hasClass('active') === false ){
			$('#curriculog-dashboard-column').addClass('active');
		}
		$('#curriculog-summary-column').animate({'left': detailClosed}, 400,
			function() {
				$('.summary.active').removeClass('active');
				$('#curriculog-summary-column').removeClass('active');
        if (!cui_enabled) {
          objDom.verticalStretchList();
        }
				Curriculog.Actions.log('flyout-closed');
			}
		);
	};

	objAccount.markRecipients = function() {
		if ( $("#detail-0").length > 0 ) {
			$("#detail-0").removeClass('open-summary');
		}

		$('#users-to li').each(function(){
			var accountId = $(this).find('input[name="id"]').val();
			$("#detail-" + accountId).addClass('collab').find('button.action-remove-collaborator').addClass('active').siblings().removeClass('active');
		});

		objAccount.resetMessageButtons();
	};

	objAccount.resetMessageButtons = function() {

		if ($('#users-to li').size() > 0 ){
			// add email
			$("#curriculog-list-column-results-content > li:not(.collab)")
						.find('button.action-add-collaborator').addClass('active')
						.siblings('button.action-send-email').removeClass('active');
		} else {
			// start message
			$("#curriculog-list-column-results-content > li:not(.collab)")
						.find('button.action-add-collaborator').removeClass('active')
						.siblings('button.action-send-email').addClass('active');
		}

		objAccount.verticalStretchList();

	};


	objAccount.validateEmailMessage = function() {

		function hasUsers() {
			if ($('#users-to li').length === 0) {
				return false;
			}

			return true;
		}

		$.validity.start();

		$('#to-id').assert(hasUsers, 'You must select at least one person to send a personal message');
		$('#personal-message-subject').require("A subject is required to send a personal message");
		$('#personal-message-msg').require("A message is required to send a personal message");

		var result = $.validity.end();

		return result.valid;
	};

	objAccount.sendMessage = function() {
		var message = {
			to : '',
			subject : '',
			message : '',
			copySelf : ''
		};

		// Concat email ids
		$('#users-to li').each(function(){
			message.to += $(this).find('input[name="id"]').val().trim() + ',';
		});

		message.to = message.to.substring(0, message.to.length - 1);
		message.from = $("#curriculog-send-message-column input[name='from-id']").val();
		message.subject = $("#curriculog-send-message-column input[name='subject']").val();
		message.message = $("#curriculog-send-message-column textarea[name='message']").val();
		message.copySelf = $("#curriculog-send-message-column input[name='copySelf']").is(':checked');

		if (objAccount.validateEmailMessage()){
			$.post("/message.json", message, function(result){
				if (result.success > 0) {
					$('#growls').notify("create","saved-template", {
						title: 'Message Sent',
						text: 'Your personal message has been sent.'
					});
					objAccount.clearSendMessageForm();
					objAccount.resetMessageButtons();
				} else {
					$('#growls').notify("create","warning-template", {
						title: 'Warning',
						text: 'Your personal message could not be sent at this time.'
					});
				}
			});
		}
	};

	objAccount.clearSendMessageForm = function() {
		$('div.qtip-active').remove();
		$('#users-to').children('li').remove();
		$('.collaborators .note').text('Click the email icon next to the user you want to add to this message.');

		$('button.action-remove-collaborator').removeClass('active');
		$('button.action-send-email').removeClass('active');
		$('button.action-add-collaborator').addClass('active');

		// $('#users-to').append('<div class="note">Click the email icon next to the user you want to add to this message.</div>');
		// $("#curriculog-send-message-column input[name='from-id']").val('');
		$("#curriculog-send-message-column input[name='subject']").val('');
		$("#curriculog-send-message-column textarea[name='message']").val('');
		$("#curriculog-send-message-column input[name='copySelf']").prop('checked',true);

		// if ($('#curriculog-send-message-column').hasClass('active')) {
		// 	$('#curriculog-send-message-column').removeClass('active')
		// 	$('#curriculog-dashboard-column').addClass('active');
		// }

		// objAccount.hideAccountFlyout();
	};

	// Settings for the account
	objAccount.saveSettings = function(accountId, admin) {
		var summary;
		var detail;

		if (admin === undefined) {
			summary = 'summary-' + accountId;
			detail = 'detail-' + accountId;
		} else {
			summary = 'summary-user-' + accountId;
			detail = 'user-' + accountId;
		}

		/**
		 * This is not functional
		 */
		var settings = [];
		var event = {
			type : null
		};
		var valid = true;

		$('#user-settings-form select:not(:disabled), #user-settings-form input[type="text"]:not(:disabled), #user-settings-form input[type="checkbox"]:not(:disabled)').each(function(index){
			var value = 0;

			// validate on submit
			if ($(this).hasClass('validate-integer')) {
				if ( !(objSettings.validate($(this),event, 'integer'))){
					valid = false;
					return false;
				}
			} else if ($(this).hasClass('validate-url')) {
				if ( !(objSettings.validate($(this),event, 'integer'))){
					valid = false;
					return false;
				}
			}

			if ($(this).attr('type') == 'checkbox') {
				value = (this.checked ? "1" : "0");
			} else {
				value = $(this).val();
			}

			var setting = {
				name : $(this).attr('id').replace('user-' + accountId + '-', ''),
				value : value
			};

			settings.push(setting);

		});

		$.ajax({
			url: '/account:' + accountId + '/settings.json',
			type: 'put',
			data: {settings: JSON.stringify(settings)},
			beforeSend: function() {
				objDom.addMask('#' + summary + ' .summary-content:eq(3)');
			},
			success: function(result){
				objDom.removeMask('#' + summary + ' .summary-content:eq(3)');
				if (parseInt(result.success, 10) == 1) {
					$('#growls').notify("create","saved-template", {
						title: 'User\'s Settings Saved',
						text: 'The settings have been successfully saved.'
					});

					Curriculog.Actions.log('user-settings-saved');

				} else {
					$('#growls').notify("create","warning-template", {
						text: 'The settings were not saved.'
					});
				}
			}
		});

	};

	/**
	 * Cancel Settings and set to settings in db
	 */
	objAccount.cancelSettings = function(accountId, admin) {
		var summary;

		if (admin === undefined) {
			summary = 'summary-' + accountId;
		} else {
			summary = 'summary-user-' + accountId;
		}

		/**
		 * Make ajax call to get settings from DB
		 */
		$.ajax({
			url: '/accounts:' + accountId + '/cancelSettings.json',
			type: 'get',
			beforeSend: function() {
				objDom.addMask('#' + summary + ' .summary-content:eq(-2)');
			},
			success: function(result){
				objDom.removeMask('#' + summary + ' .summary-content:eq(-2)');

				if (result.userSettings !== undefined) {

					var settings = result.userSettings.settings;

					$('#' + summary + ' select:not(:disabled), #' + summary + ' input[type="checkbox"]:not(:disabled)').each(function(index){
						var value = '';
						key = $(this).attr('id').replace('user-'+ accountId +'-', '');

						if (settings[key] !== undefined) {
							value = settings[key];

							/**
							 * Reset the input values
							 */
							if ($(this).attr('type') == 'checkbox' ){
								if (parseInt(value, 10) > 0) {
									$(this).prop("checked", true);
								} else {
									$(this).prop("checked", false);
								}
							} else {
								$(this).val(value);
							}
						}
					});
				}
			}
		});

	};

	//
	// Personal Information Form
	//

	/**
	 * Is this the admin page?
	 * @return {Boolean}
	 */
	var isAdminPage = function () {
		return window.location.pathname.match(/admin/) !== null;
	};

	/**
	 * Is the 'Accounts' tab active in the hierarchy?
	 * @return {Boolean}
	 */
	var accountsTabIsActive = function () {
		var hierarchyTab = $('#curriculog-hierarchy-column-tabs li.active');
		if (!hierarchyTab.length) {
			return false;
		}
		var activeTab = hierarchyTab.attr('class').match(/users-tab/);
		return activeTab !== null;
	};

	/**
	 * Parse info out of the Personal Information form on the User Accounts page
	 * and on the Hierarchy Accounts page
	 * @param  {jQuery} flyout -- jQuery object of the flyout that contains the
	 *                         user form.
	 * @return {Object}
	 */
	var parseForm = function (flyout) {


		var data = {
			firstName : flyout.find('input[name="firstName"]').val(),
			lastName : flyout.find('input[name="lastName"]').val(),
			email: flyout.find('input[name="email"]').val()
		};

		// If we're on the admin page then parse the status and return it
		// with the data.
		var status = flyout.find('input[name="status"]').is(':checked');
		if (isAdminPage()) {
			data.status = status ? 'active' : 'inactive';
		} else {
			// Inactive users do not show up on the user accounts page.
			data.status = 'active';
		}

		// If we're on the admin page then parse whether the user is remote
		// and return the userName or password based on the result
		var isRemote = ($('input[name="isRemote"]').is(':checked')) ? 1 : 0;
		if (!isRemote) {
			data.password = $('input[name="password"]').val();
		} else {
			data.userName = $('input[name="userName"]').val();
		}
		data.isRemote = isRemote;

		return data;
	};

	/**
	 * Validate the Personal Information form on the User Accounts flyout and
	 * on the Hierarchy Accounts flyout.
	 * @param  {jQuery} flyout jQuery object of the flyout.
	 * @return {Object}        The object returned from validity /
	 */
	var validateUserForm = function (flyout) {
		var isRemote = (flyout.find('input[name="isRemote"]').is(':checked')) ? 1 : 0;
		var isAdminFlyout = (flyout.find('input[name="password"]')) ? true : false;

		$.validity.start();
		flyout.find('input[name="firstName"]').require();
		flyout.find('input[name="lastName"]').require();
		flyout.find('input[name="email"]').require().match('email');

		if (isAdminFlyout && !isRemote) {
			flyout.find('input[name="password"]').minLength(8);
			flyout.find('input[type="password"]').equal("Passwords do not match.");
		} else if (isAdminFlyout && isRemote) {
			flyout.find('input[name="userName"]').require();
		}

		return $.validity.end();

	};

	/**
	 * Refreshes the hierarchy and accounts flyout and list column.
	 */
	var updateHierarchyDOM = function () {
		// Refresh the hierarchy flyout.
		var summaryClass = $('.summary').attr('id').match(/summary-(.*)-(.*)/);
		var flyoutType = summaryClass[1];
		var flyoutID = summaryClass[2];
		objHierarchy.getFlyout(flyoutID, flyoutType);

		// Refresh the users list.
		if (accountsTabIsActive()) {
			objHierarchy.getAccounts();
		}
	};

	// FIXME: refactor this so that it doesn't need all these arguments.
	var updateUserDOM = function ($userListItem, $summaryFlyout, accountId, user) {
		// Update the DOM for the user.
		// Upate the name in the list column and in the summary.

		escapedLastName = escapeUserInput(user.lastName);
		escapedFirstName = escapeUserInput(user.firstName);

		$userListItem.find('.list-name')
			.add($summaryFlyout.find('.summary-title'))
			.html(escapedLastName + ', ' + escapedFirstName);

		// Update the user name in the "To" field on the "Send Message" flyout.
		if ($('#collaborator-' + accountId).length) {
			$('#collaborator-' + accountId + ' input[name="id"]')[0]
				.previousSibling
				.previousSibling
				.data = escapedLastName + ', ' + escapedFirstName;
		}
		if ($('input[name="from-id"]').val() === accountId) {
			// Send Message Tab and saving your settings
			$('input[name="from-id"]')
				.prev()
				.val(escapedLastName + ', ' + escapedFirstName);
			$('#curriculog-site-userbox div.user-details')
				.html(escapedFirstName + ' ' + escapedLastName);
		}

		$('#detail-' + accountId)
			.find('input[name="firstName"]')
			.val(escapedFirstName)
			.siblings('input[name="lastName"]').val(escapedLastName)
			.siblings('input[name="email"]').val(user.email);
	};

	var userSaveError = function (errorMsg) {
		if ((errorMsg === undefined) || (errorMsg === '')) {
			errorMsg = 'The user was not saved correctly. ' +
					'Please try again or contact support.';
		}

		$('#growls').notify('create', 'warning-template', {
			title: 'Error',
			text: errorMsg
		});
	};

	/**
	 * Handles the updating the "Personal Information" form on the User Accounts
	 * flyout, My Settings flyout, Admin User Accounts flyout, and the Hierarcy
	 * flyout.
	 * @param  {[type]} accountId -- the user ID.
	 * @return {jqXHR}
	 */
	objAccount.update = function (accountId) {
		var summary = '#summary-' + accountId,
			adminSummary = '#summary-user-' + accountId,
			detail = '#detail-' + accountId,
			adminDetail = '#user-' + accountId,
			$summaryFlyout = $(summary + ',' + adminSummary),
			$userListItem = $(detail + ',' + adminDetail);

		var results = validateUserForm($summaryFlyout);

		if (!results.valid) {
			return false;
		}

		var user = parseForm($summaryFlyout);

		var xhr = $.ajax({
			url: '/account:' + accountId + '.json',
			type: 'PUT',
			contentType: 'application/json',
			data: JSON.stringify(user),
			beforeSend: function() {
				objDom.addMask($summaryFlyout);
			},
			success: function(data){
				objDom.removeMask($summaryFlyout);

				if (isAdminPage()) {
					updateHierarchyDOM();
				} else {
					updateUserDOM($userListItem, $summaryFlyout, accountId, user);
				}

				if (data.result.success === 0) {
					console.log(data);
					// throw growl
					var errorMsg = 'The user was not able to be edited. ' + data.result.errors.join();
					userSaveError(errorMsg);
				} else {
					Curriculog.Actions.log('user-info-saved');
				}
			},
			error: userSaveError
		});
		return xhr;
	};

	objAccount.addUser = function() {
		var accountId = 0;

		var adminSummary = '#summary-user-' + accountId,
			$summaryFlyout = $(adminSummary);

		var results = validateUserForm($summaryFlyout);

		if (!results.valid) {
			return false;
		}

		var user = parseForm($summaryFlyout);

		var xhr = $.ajax({
			url: '/account.json',
			type: 'post',
			contentType: 'application/json',
			data: JSON.stringify(user),
			beforeSend: function() {
				objDom.addLoadingMask('#user-details-form');
			},
			success: function(data){

				if (+data.result.success > 0) {
					hierarchyObject.getAccounts();
					hierarchyObject.getFlyout(data.result.success, 'user');
					objDom.removeMask('#user-details-form');

					Curriculog.Actions.log('user-info-saved');

				} else {
					var errorMsg = 'The user was not able to be added. ' + data.result.errors.join();
					userSaveError(errorMsg);
					objDom.removeMask('#user-details-form');
				}
			},
			error: userSaveError
		});
		return xhr;

	};

	objAccount.showMySettings = function(email){
		listObject.restrictList('email', email, '', function(){
			objAccount.markRecipients();
			$('#name-wrapper').children('a').removeClass('active');
		});
	};

	objAccount.getPin = function(userId){
		var dialog = objDialog.createBasicDialog('user-pin', 'User Pin',function(dialog, defaults) {
			// Message
			$(dialog).append('<p>Your user pin is:</p><br />');
			$(dialog).append('<p id="user-pin-holder"><img src="/images/ajax-loader.gif" alt="loading" /></p>');

			$.ajax({
				url: '/account:' + userId + '/getPin.json',
				type: 'get',
				success: function(result){
					if (parseInt(result.success, 10) > 0) {
						$(dialog).find('p#user-pin-holder').html(result.success);
					} else {
						$(dialog).find('p#user-pin-holder').addClass('error').html('An error has occurred.<br />Please contact an Administrator.');
					}
				}
			});

			// Actions
			defaults.buttons = {
				'Ok': function() {
					$(this).dialog('close');
				}
			};
			// Cleanup
			defaults.close = function(event, ui) {};
			$(dialog).dialog(defaults);

		});

	};

	objAccount.updatePin = function(userId) {

		var dialog = objDialog.createDOMDialog('signature-pin-dialog', function(dialog, defaults) {
			// Actions
			change_pin = function() {

				$.validity.start();
				$("#signature_pin").require().match('integer').minLength(4).greaterThan(0);
				var result = $.validity.end();

				if (result.valid) {
					$.ajax({
						url: '/account:' + userId + '/updatePin.json',
						type: 'put',
						data: {
							pin: $('#signature_pin').val()
						},
						success: function(result){
							if (Number(result.success) === 1) {
								// change pin link
								$('#summary-user-' + userId + ' .change-pin').text('Change Pin');

								// clean out dialog values
								$("#signature_pin").val('');

								$(dialog).dialog('close');

								Curriculog.Actions.log('user-pin-updated');
							} else {
								$('#growls').notify("create","warning-template", {
									title: 'Error Modifying Pin',
									text: 'The user\'s pin was not able to be changed. Please try again or contact support.'
								});
							}
						}
					});
				}

			};
			var change_pin_text = $('#summary-user-' + userId + ' .change-pin').text();
			defaults.buttons = {};
			defaults.buttons[change_pin_text] = change_pin
			defaults.buttons['Cancel'] = function(){
				$(this).dialog('close');
			}
			// Cleanup
			defaults.close = function(event, ui) {
				$('#signature_pin').attr('value', ''); // reset pin field
				$('#signature_pin').removeClass('error');
				$('#signature-pin-dialog').find('.error').remove();
			};
			$(dialog).dialog(defaults);

		});

	};

	/**
	 * Cancel changes made to user account
	 */
	objAccount.cancelUser = function(accountId, admin) {
		var summary;

		if (admin === undefined) {
			summary = 'summary-' + accountId;
		} else {
			summary = 'summary-user-' + accountId;
		}

		/**
		 * Make ajax call to get settings from DB
		 */
		$.ajax({
			url: '/accounts:' + accountId + '/cancel.json',
			type: 'get',
			beforeSend: function() {
				objDom.addMask('#' + summary + ' .summary-content:eq(1)');
			},
			success: function(result){
				objDom.removeMask('#' + summary + ' .summary-content:eq(1)');

				var user = result.user;
				if (user !== undefined && user !== null) {
					serverSettings = {
						firstName : user.firstName,
						lastName : user.lastName,
						email : user.email,
						userName : user.userName,
						status : user.status,
						isRemote : user.isRemote,
					};

					$('#' + summary + ' .summary-content:eq(1) input').each(function(index){

						var key = $(this).attr('name');
						var value = serverSettings[key];

						if (!(key in serverSettings)) {
							return;
						}

						// Reset the input values, if the key exists
						if (key === 'status') {
							if (value === 'active') {
								$(this).prop("checked", true);
							} else {
								$(this).prop("checked", false);
							}
						} else if (key === 'isRemote') {
							if (value === true) {
								$(this).prop("checked", true);
								$('.remote-options', $(this).closest('div')).show();
								$('.local-options', $(this).closest('div')).hide();
							} else {
								$(this).prop("checked", false);
								$('.remote-options', $(this).closest('div')).hide();
								$('.local-options', $(this).closest('div')).show();
							}
						} else {
							$(this).val(value);
						}
					});
				} else {
					// Cancel button was clicked in the new user flyout
					// There was no user created, so user.get() returns NULL
					closeFlyout();
				}
			}
		});
	};

	objAccount.changePassword = function(accountId) {

		var dialog = objDialog.createDOMDialog('change-password-dialog', function(dialog, defaults) {

			var isAdmin = $('#curriculog-content').hasClass('admin');
			if(isAdmin) {
				$(dialog).find('span#change-password-name').html($('#user-details-firstName').val().trim() + ' ' + $('#user-details-lastName').val().trim());
			}


			// Actions
			defaults.buttons = {
				'Update Password': function() {

					// Enter new password twice. 8 char min (validation required). Ticket #133
					var currentPassword = $('#current_password').val();
					var newPassword = $('#new_password').val();
					var confirmPassword = $('#confirm_password').val();

					$.validity.start();

					// make sure current password is correct (user side only)
					if ($('#current_password').length > 0) {
						$('#current_password').require().matchcurrentpassword(accountId);
					}

					$('#new_password').minLength(8);
					$('#change-password-dialog input[type="password"]:not(#current_password)').equal("Passwords do not match.");
					var result = $.validity.end();

					if(result.valid) {

						// confirm dialog
						var dialog2 = objDialog.createBasicWarningDialog('confirm-change-password', function(dialog2, defaults2){
							if (isAdmin) {
								$(dialog2).append('<p>Are you sure you want to change their password? You will need to notify the user of their new password.</p>');
							} else {
								$(dialog2).append('<p>Are you sure you want to change your password?</p>');
							}


							defaults2.buttons = {
								'Yes' : function () {

									if (currentPassword === undefined)
									{
										currentPassword = '';
										type = 'admin';
									}
									else
									{
										type = 'user';
									}

									var postParam = {
										//currentPassword: currentPassword,
										newPassword : newPassword,
										confirmPassword : confirmPassword,
										type : type
									};

									$.ajax({
										url: '/account:' + accountId + '/changePassword.json',
										type: 'put',
										data: postParam,
										success: function(result){
											if (parseInt(result.success, 10) == 1) {
												$(dialog2).dialog('close');
												$(dialog).dialog('close');
											} else {
												$('#growls').notify("create","warning-template", {
													title: 'Error Changing Password',
													text: 'The user\'s password was not able to be changed. Please try again or contact support.'
												});
												$(dialog2).dialog('close');
											}
										}
									});
								},
								'No' : function () {
									$(dialog2).dialog('close');
									$(dialog).dialog('close');
								}
							};
							$(dialog2).dialog(defaults2);

						});

					} else {
            $('#change-password-dialog .error').css('display', 'block');
          }

				},
				Cancel: function(){
					$(this).dialog('close');
					$.validity.clear();
				}
			};
			// Cleanup
			defaults.close = function(event, ui) {
				$('#current_password').val('');
				$('#new_password').val('');
				$('#confirm_password').val('');
			};
			$(dialog).dialog(defaults);

		});
	};
	objAccount.swapLock = false;
	objAccount.swapAccountRole = function(obj, callback) {
		// change out the save in participant picker for a UI-only swap of user roles
		// then finalize at the end. Finalize should be disabled until all roles are replaced
		// cancel wipes the slate clean without touching back end
		if (this.swapLock) {
			return;
		}
		this.swapLock = true;
		var self = this;

		var dataParams = {
			display: 'swapUser'
		};
		var getUrl;
		// var putUrl;
		var mask;

		if (obj.type == 'user-role') {
			// swap user role
			getUrl = '/admin/role:' + obj.id + '/getRoleAndUser';

			// this is the mask if we are in the user flyout
			mask = $('#entity-parents-form').parent().parent();

			// we need a different mask if we are in the user-role flyout
			if (mask.length === 0) {
				mask = $('#user-role-form').parent().parent();
			}

			dataParams.userId = obj.userId;
		} else {
			// delete user
			getUrl = '/admin/account:' + obj.id + '/getRoles';

			// this mask is used if we are deleting from the user list
			mask = '#curriculog-hierarchy-column-content';
		}

		$.ajax({
			url: getUrl,
			type: 'GET',
			data: dataParams,
			success: function(result) {
				$('body').append(result);
				swapAccountRoleDialog(callback);
				$('#finalize-delete').attr('disabled', true);
			},
		});

		var swapAccountRoleDialog = function(callback) {
			var dialog = objDialog.createDOMWarningDialog('swap-user-dialog', function(dialog, defaults) {
				// Click Event for opening the participant dialog.
				if (obj.type == 'user-role') {
					$('.participant-picker').participantpicker(
						{
							'type':'swap',
							'showRoles': false,
							'showRoleTypes': false,
							'buttonText': 'Select user',
							'selectText': 'Select user',
							'dbData': '',
							'selectionRequired': true
						}
					);

				} else {
					$('.participant-picker').participantpicker(
						{
							'type':'swap',
							'showRoles': false,
							'showRoleTypes': false,
							'buttonText': 'Select user',
							'selectText': 'Select user',
							'selectForAll': true,
							'allButtonLabel': 'Apply user to all role transfers',
							'dbData': '',
							'selectionRequired': true
						}
					);
				}

				defaults.buttons = [
					{
						id: 'finalize-delete',
						text: 'Finalize Delete',
						click: _.debounce(function() {
							var workload;

							if (obj.type == 'user') {
								// target_user_id, replacement_user_id, originator_replacement_id, role_replacements

								roles = [];
								var directReplacement = 0;
								var originator = 0;

								$('#swap-user-dialog .entity-roles').find('.role').each(function() {
									var role = [];
									// need a tuple of [user id, role id]
									role.push(+$(this).find('.participant-picker .user')
										.attr('id')
										.replace('swap-user-', ''));
									role.push(+$(this).attr('id').replace('swap-role-', ''));
									roles.push(role);
								});

								if ($('#swap-user-dialog #swap-participant').length > 0) {
									directReplacement = +$(this).find('.participant-picker .user')
										.attr('id')
										.replace('swap-user-', '');
								}

								if ($('#swap-user-dialog #swap-originator').length > 0) {
									originator = +$(this).find('.participant-picker .user')
										.attr('id')
										.replace('swap-user-', '');
								}

								functionName = 'swap_user';
								workload = {
									target_user_id: +$('#swap-user-id').val(),
									role_replacements: roles,
									replacement_user_id: +directReplacement,
									originator_replacement_id: +originator
								};

							} else {
								// target_user_id, replacement_user_id, role_id
								var user;
								var role;
								$('#swap-user-dialog .entity-roles').find('.role').each(function() {
									role = +$(this).attr('id').replace('swap-role-', '');
									user = +$(this).find('.participant-picker .user')
											.attr('id')
											.replace('swap-user-', '');
								});

								var oldUser = +$('#swap-user-id').val();

								// test to see if the user selected in the participant
								// picker already has this role
								var newUserAlreadyInRole = app.userRoles.findWhere({
									user_id: user,
									role_id: role,
								});

								functionName = 'swap_user_role';
								workload = {
									target_user_id: oldUser,
									replacement_user_id: user,
									role_id: role
								};
							}

							$.ajax({
								type: 'POST',
								url: '/gearman-job.json',
								contentType: 'application/json',
								data: JSON.stringify({
									functionName: functionName,
									workload: workload
								}),

								beforeSend: function () {
									// domObject.addLoadingMask('#hermes-content');
									// domObject.addMask(mask);
									$('#finalize-delete').attr('disabled', true);
								},

								success: function (results) {
									// close the dialog
									$('div.qtip-active').remove();
									$(dialog).dialog('close');
									$(dialog).remove();
									self.swapLock = false;

									getBackgroundJobStatus(results.jobHandle, mask, 'User Swap', function() {

										if(workload.target_user_id == currentUserID){
											location.href = '/';
										}
										var onAccountsTab = $('#curriculog-hierarchy-column-tabs li.active').attr('class').match(/(\w*)-tab/)[1] == 'users';

										// update the Backbone model so our views refresh
										if (role && oldUser && user) {
											// swapping user in role from user role flyout or user flyout
											app.userRoles.swapUser(role, oldUser, user);

											// close the flyout if we are not in the accounts module
											// and we are swapping in a user that already has this role.
											if (!onAccountsTab && newUserAlreadyInRole !== undefined) {
												closeFlyout(callback);
											} else {
												callback && callback();
											}
										} else {
											// swapping the role when deleting the user
											$.each(workload['role_replacements'], function (index, value) {
												var swappedRoleID = value[1];
												var newUserID = value[0];
												var oldUserID = workload['target_user_id']
												app.userRoles.swapUser(swappedRoleID, oldUserID, newUserID)
											});

											closeFlyout();
										}

										// load the right list
										if (onAccountsTab) {
											// reload the flyout if we are in accounts
											var summaryId = $('.summary').attr('id').match(/summary-(.*)-(.*)/);
											if (summaryId && summaryId.length) {
												objHierarchy.getFlyout(summaryId[2], summaryId[1]);
											}

											objHierarchy.getAccounts();
										}
									},
									function(jobResults){
										var taskName = 'User Swap';
										$('#growls').notify("create","warning-template", {
											title: 'Warning',
											text: 'An error occurred while attempting to ' + taskName + '. Please try again or contact a system administrator.',
										}, {
											expires: false,
										});
									}
								);
								}
							});

						}, 500)
					},
					{
						id: 'cancel-delete',
						text: 'Cancel',
						click: function() {
							$(dialog).dialog('close');
							$(dialog).remove();
							self.swapLock = false;
							callback && callback();
						}
					}];

          defaults.close = function(event, ui) {
            $(dialog).remove();
            self.swapLock = false;
            callback && callback();
          };

				$(dialog).dialog(defaults);
			});
		};
	};

	objAccount.swapAccountAgendaAdmin = function(obj) {

		// DEPRECATED, but leaving this for agenda admin swapping, for now

		var dataParams = {
			display: 'swapUser'
		};
		var getUrl;
		var putUrl;
		var mask;

		if (obj.type == 'user-agenda') {
			getUrl = '/admin/account:' + obj.id + '/getCommittee';
			putUrl = '/admin/account:' + obj.id + '/swapAgendaAdmin.json';
			mask = '#committees-choosen-' + obj.id;
			dataParams.committee = obj.committee;
		}

		return $.ajax({
			url: getUrl,
			type: 'GET',
			data: dataParams,
			success: function(result) {
				$('body').append(result);
				objAccount.swapAccountRoleDialog(obj, putUrl, mask);
				$('#finalize-delete').attr('disabled', true);
			}
		});
	};

	objAccount.swapAccountRoleDialog = function(item, putUrl, mask) {
		var dialog = objDialog.createDOMWarningDialog('swap-user-dialog', function(dialog, defaults) {
			// Click Event for opening the participant dialog.

			$('.participant-picker').participantpicker(
				{
					'type':'swap',
					'selectNewAgendaAdmin': true,
					'buttonText': 'Select agenda admin',
					'selectText': 'Select user',
					'dbData': '',
					'selectionRequired': true
				}
			);


			defaults.buttons = [
				{
					id: 'finalize-delete',
					text: 'Finalize Delete',
					click: _.debounce(function() {
						workload = {
							method_args: {
								fromUser: $('#swap-user-id').val(),
								committeeId: parseInt($('#swap-committee-id').val(), 10),
								toUser: +$(this).find('.participant-picker .user')
												.attr('id')
												.replace('swap-user-', '')
							}
						}

						$.ajax({
							type: 'POST',
							url: '/gearman-job.json',
							contentType: 'application/json',
							mask: $('#entity-parents-form').parent().parent(),
							data: JSON.stringify({
								functionName: 'swap_agenda_admin_task',
								workload: workload
							}),
							beforeSend: function() {
								domObject.addMask(this.mask);
								$('#finalize-delete').attr('disabled', true);
								$('div.qtip-active').remove();
								$(dialog).dialog('close');
								$(dialog).remove();
							},

							success: function (results) {
								getBackgroundJobStatus(results.jobHandle, this.mask, 'Swap Agenda Admin', function (jobResults) {
									// Refresh the list to show the replacements.
									var summaryId = $('.summary').attr('id').match(/summary-(.*)-(.*)/);
									if (summaryId && summaryId.length) {
										objHierarchy.getFlyout(summaryId[2], summaryId[1]);
									}

									// load the right list
									if ($('#curriculog-hierarchy-column-tabs li.active').attr('class').match(/(\w*)-tab/)[1] == 'users') {
										// window.location.href='/admin/hierarchy?tab=accounts';
										objHierarchy.getAccounts();
									}
								},
								function(jobResults){
									var taskName = 'Swap Agenda Admin';
									$('#growls').notify("create","warning-template", {
										title: 'Warning',
										text: 'An error occurred while attempting to ' + taskName + '. Please try again or contact a system administrator.',
									}, {
										expires: false,
									});
								});
							},

							error: function () {
								domObject.removeMask(this.mask);
							},
						});

					}, 500)
				},
				{
					id: 'cancel-delete',
					text: 'Cancel',
					click: function() {
						$(dialog).dialog('close');
						$(dialog).remove();
						// recheck the checkbox on cancel
						$('#user-'+item.id+'-committee-'+item.committee+'-admin').prop('checked', true);
					}
				}];

			$(dialog).dialog(defaults);
		});
	};

	objAccount.updateSwapUserDialog = function(currentUser, newUsers, roleIds, directParticipant, originator, callback) {
		// swap role(s)

		if ( (newUsers.length === 0) && (directParticipant === 0) && (originator === 0) ) {
			return false;
		}

		$.each(roleIds, function(index, roleId) {

			$('#swap-role-' + roleId + ' .participant-picker').addClass('completed');
			$('#swap-role-' + roleId + ' .participant-picker a').contents().remove();

			//var roleUsers = $();
			$.each(newUsers, function(userIndex, user) {

				var html = $('<span/>', {
					id: 'swap-user-'+user.id,
					class: 'hierarchy-item participant-option user',
					html: $('<label></label>').html(user.name)
				}).prepend($('<span class="screen-reader-text">Change selected user</span>')).appendTo($('#swap-role-' + roleId + ' .participant-picker a'));

			});

		});

		// swap direct participant
		if (directParticipant) {
			$('#swap-participant .participant-picker').addClass('completed');
			$('#swap-participant .participant-picker a').contents().remove();

			$.each(newUsers, function(userIndex, user) {
				var html = $('<span/>', {
					id: 'swap-user-'+user.id,
					class: 'hierarchy-item participant-option user',
					html: $('<label></label>').html(user.name)
				}).appendTo($('#swap-participant .participant-picker a'));

			});
		}

		// swap originator
		if (originator) {
			$('#swap-originator .participant-picker').addClass('completed');
			$('#swap-originator .participant-picker a').contents().remove();

			$.each(newUsers, function(userIndex, user) {
				var html = $('<span/>', {
					id: 'swap-user-'+user.id,
					class: 'hierarchy-item participant-option user',
					html: $('<label></label>').html(user.name)
				}).appendTo($('#swap-originator .participant-picker a'));

			});
		}

		if ($('#swap-user-dialog .entity-roles .participant-picker:not(.completed)').length == 0) {
			$('#finalize-delete').removeAttr('disabled');
		}

		callback && callback();
	}


	objAccount.destroy = function(obj, callback) {
		if(this.swapLock){
			return;
		}
		this.swapLock = true;
		self = this;
		var dialog = objDialog.createBasicWarningDialog('delete-user-dialog', function(dialog, defaults) {

			$(dialog).append('Are you sure you want to remove user <span class="strong">'+ obj.name + '</span>?');

			defaults.buttons = {
				'Delete User': function() {

					$.ajax({
						url: "/admin/accounts:" + obj.id,
						type: 'DELETE',
						beforeSend: function() {
							domObject.addMask('#curriculog-list-column-results-content');
						},
						success: function(){
							domObject.removeMask('#curriculog-list-column-results-content');
							//$('div.qtip-active').remove();
							//listObject.refreshList();
							callback && callback(obj);
						},
						complete: function() {
							self.swapLock = false;
						}
					});

					$(this).dialog('close');
					$(this).remove();
				},
				Cancel: function() {
					$(this).dialog('close');
					$(this).remove();
					self.swapLock = false;
				}
			};

			$(dialog).dialog(defaults);
		});
	}

	objAccount.verticalStretchList = function() {
		domObject.verticalStretchList();
	}

	return objAccount;
};
